export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тейкер"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мейкер"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тейкер ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мейкер ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви платите"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви отримуєте"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Час очікування"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ім'я"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Банківський рахунок/Гаманець"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Опис"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Немає назви банку"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Немає банківського рахунку"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ім'я не вказано"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунок не вказано"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зовнішній"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Внутрішній"])}
}